import {
  type AppConfig,
  AppConfigProvider,
  createFormatters,
} from "@indietabletop/appkit";
import type { ReactNode } from "react";
import { client } from "../../client.ts";
import { database } from "../../database.ts";
import { hrefs } from "../../hrefs.ts";
import icon from "./icon.png";

const appkitConfig: AppConfig = {
  app: {
    name: "Space Gits",
    icon,
  },
  isDev: import.meta.env.DEV,
  client,
  hrefs,
  placeholders: {
    email: "E.g. krunk@example.com",
  },
  database: database,
  fmt: createFormatters("en-GB"),
};
export function AppkitConfigProvider(props: { children: ReactNode }) {
  return (
    <AppConfigProvider config={appkitConfig}>
      {props.children}
    </AppConfigProvider>
  );
}
